import { useId } from 'react';
import { useDialogClose } from '../hooks/useDialogClose';

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// Generic "are you sure?" dialog. Reuses the .delete-dialog-* styles and the
// exit-animation timing already used by DeleteChatDialog.
export function ConfirmDialog({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { isClosing, handleClose } = useDialogClose(onCancel);
  const titleId = useId();

  return (
    <div className={`delete-dialog-overlay${isClosing ? ' overlay-closing' : ''}`} onClick={handleClose}>
      <div
        className={`delete-dialog${isClosing ? ' dialog-closing' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-dialog-title" id={titleId}>{title}</div>
        <div className="delete-dialog-text">{message}</div>
        <div className="delete-dialog-actions">
          <button className="btn-ghost" type="button" onClick={handleClose}>{cancelLabel}</button>
          <button className="btn-danger" type="button" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
